import QRCode from 'qrcode.react';
import React from 'react';
import '../App.css';

export default class BarcodeGenerator extends React.Component {
    render() {
        return <div className="Center">{this.props.jurorID ? <QRCode value={this.props.jurorID.toString().padStart(7, '0')} /> : ' '}</div>;
    }
}
